import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const COURSE_TYPE_NODE_FRAGMENT = gql`
  fragment CourseTypeNodeFragment on CourseTypeNode {
    ...MetadataNodeFragment
    isIgnored
    isDefaultFilter

    replaces {
      ...MetadataNodeFragment
      replaceToken
    }

    replacedBy {
      ...MetadataNodeFragment
      replaceToken
    }

    children {
      ...MetadataNodeFragment
      isIgnored
      isDefaultFilter

      replaces {
        ...MetadataNodeFragment
        replaceToken
      }

      replacedBy {
        ...MetadataNodeFragment
        replaceToken
      }

      children {
        ...MetadataNodeFragment
        isIgnored
        isDefaultFilter

        replaces {
          ...MetadataNodeFragment
          replaceToken
        }

        replacedBy {
          ...MetadataNodeFragment
          replaceToken
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default COURSE_TYPE_NODE_FRAGMENT
